import Vue from 'vue'
import VueQrcodeReader from "vue-qrcode-reader";
import vuetify from '@/plugins/vuetify'
import App from './App.vue'
import PouchDB from 'pouchdb-browser'
import pf from 'pouchdb-find'
import plf from 'pouchdb-live-find'
import pa from 'pouchdb-authentication'
import pouchVue from 'pouch-vue'
import {remotePouch} from './plugins/customPouchDbPlugin.js'


import DbPlugin from './plugins/InternalDbPlugin'

import VueKatex from 'vue-katex'

import 'katex/dist/katex.min.css';

import router from './router'
import store from './store'

import axios from 'axios'
import VueAxios from 'vue-axios'
import VuePapaParse from 'vue-papa-parse'
import VSwitch from 'v-switch-case'
import './registerServiceWorker'
import NumericField from './components/utils/NewNumericField'
import CalendarField from './components/utils/CalendarField'
import YearField from './components/utils/YearField'
import { formatDatefromTS } from './utils/commonUtils'
import { verifyPermission, verifyReportPermission } from './utils/rolesManagement'
import { remote_db_url } from './utils/dbUtility.js'

PouchDB.plugin(pf);
PouchDB.plugin(plf);
PouchDB.plugin(pa);


const PouchRemoteAddress = PouchDB.defaults({
  prefix:remote_db_url
})

console.log('POUCH', Vue);


Vue.use(pouchVue, {
  pouch: PouchDB, // optional if `PouchDB` is available on the global object
});


Vue.use(remotePouch, {
  pouch: PouchRemoteAddress, // optional if `PouchDB` is available on the global object
});





import _ from 'lodash'
Vue.prototype._ = _

//Vue.use(DbPlugin)
Vue.use(VueAxios, axios)
Vue.use(VueKatex)
Vue.use(VuePapaParse)
Vue.use(VSwitch)
Vue.use(VueQrcodeReader);
Vue.component('NumericField', NumericField)
Vue.component('CalendarField', CalendarField)
Vue.component('YearField', YearField)

Vue.config.productionTip = false

Vue.config.errorHandler = (err, vm, info) => {
    // err: error trace
    // vm: component in which error occured
    // info: Vue specific error information such as lifecycle hooks, events etc.
    console.log('**************** ERROR VUE', err)
        // vm.$store.commit("showSnackbar", { text: "Errore inaspettato: controllare il funzionamento, effettuare il logout e ricaricare.", color: 'error' })
        // TODO: Perform any custom logic or log to server
    if (err.message.search("'transaction' on 'IDBDatabase'") > -1 ||
        err.message.search("IDBDatabase.transaction") > -1) {
        vm.$store.commit("fatalError")
    }
};

Vue.filter('formatNumber', function(value) {
    if (!value) return ''
    value = value.toString()
    return value.replace('.', ',')
})
Vue.filter('formatDateTS', function(value) {
    return formatDatefromTS(value)
})

Vue.directive('can', {
    bind: function(el, binding, vnode) {
        if (!binding.value || !vnode.context.$store.state.user) {
            return
        }
        let user = vnode.context.$store.state.user
            // console.log("CAN DIRECTIVE", el, user.roles, binding.value, verifyPermission(binding.value.obj_type, binding.value.action, user.roles, user.report_type))
        if (!verifyPermission(binding.value.obj_type, binding.value.action, user.roles, user.report_type)) {
            vnode.elm.style.display = "none"
        }
    }
})

Vue.directive('report', {
    bind: function(el, binding, vnode) {
        if (!binding.value || !vnode.context.$store.state.user) {
            return
        }
        let user = vnode.context.$store.state.user
        if (!verifyReportPermission(binding.value.action, binding.value.op_type, binding.value.family, user.roles, user.report_type, user.review_type)) {
            vnode.elm.style.display = "none"
        }
    }
})

new Vue({
    router,
    store,
    vuetify,
    render: h => h(App),
}).$mount('#app')